import React from "react";
import Layout from "../common/layouts";
import { graphql } from "gatsby";
import Seo from "../common/seo";

import Partner from "../common/components/partner";

var partners = [
  {
    fullname: "Daniel Holmlund",
    company: "Aalon Capital LLC",
    image: "/daniel.webp",
    description:
      "Daniel Holmlund received his degree in Computer and Electrical Engineering from the University of California at Davis. He now works at Intel Corporation as a software developer and Intel community manager. He runs the Real Estate Investment club at Intel which as of June 2020 has over 700 active members. He has invested in a total of apartment units 907 units, 635 of which he has been a General Partner.",
  },
  {
    fullname: "Hilary Holmlund",
    company: "Aalon Capital LLC",
    image: "/hilary.jpg",
    description:
      "Hilary Holmlund works promoting communication with investors and partner relationships. Hilary focus on managing the many moving parts of the business and communicating with investors and tracking the finances of the business. ",
  },
  {
    fullname: "Mark Kenney",
    company: "Senior Advisor, Think Multifamily",
    image: "/mark.png",
    description:
      "Mark is a seasoned real estate investor, coach, two-time best-selling author and founder of Think Multifamily. Mark started his Apartment Investing career over 20 years ago as a side hustle, while working 70-80 hour work weeks in the corporate world.  He has purchased over 4,000 units in just the past few years in five different states. He is frequently asked to speak at Real Estate events and has a desire to help others learn how to get started and go bigger with apartment investing. Mark has a passion to help others achieve success quickly in multifamily investing. He specializes in educating others how to go BIG, fast through syndication! In his first year of coaching, he helped others acquire 2,500+ apartment units worth over $18 0M. The smallest deal any of his students purchased is 90 units…so, it is possible to go BIG, fast even if you don’t have any experience! His coaching style is “no fluff” and he is passionate about results and providing unmatched service! Mark is a graduate at Michigan State University in Accounting and is a CPA. He has also provided IT consulting for 20 years and is leveraging his vast IT experience to bring new creative technologies that will help others in the multifamily space. He has worked for organizations such as KPMG Consulting, EDS, SAP, HP, and founded Simplifying-IT which provides IT services to fortune 500 companies.",
  },
];

export default ({ props, data }) => (
  <Layout>
    <Seo
      title={`Our Team`}
      description={data.markdownRemark.frontmatter.title}
    />

    <div className="ph4">
      <div className="relative">
        <h1 className="fw1 tc f2 display dn dib-ns">Our Team</h1>
      </div>

      <div
        className="w-100 lh-copy serif pa2 flex flex-column justify-center f4"
        dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
      ></div>

      <div className="w-100 lh-copy serif pa2 flex flex-column justify-center f4">
        {partners.map((node) => (
          <Partner {...node} />
        ))}
      </div>
    </div>
  </Layout>
);

export const dataQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { name: { eq: "team__copy" } }) {
      html
      frontmatter {
        title
      }
    }
    banner: file(relativePath: { eq: "img/about__banner.jpg" }) {
      childImageSharp {
        fluid(maxHeight: 720, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
